export const inputSx = {
  '& input': {
    border: '1px solid #d6d6d6',
    borderRadius: '4px',
    boxSizing: 'border-box',
  },
  '& .MuiInput-root:after, .MuiInput-root:before, & .MuiInputBase-root:after, & .MuiInputBase-root:before':
    {
      content: 'none',
    },
};
